import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const PlanYourEventListing = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade2 = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.75,
        staggerChildren: 0.4,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const data = useStaticQuery(graphql/* GraphQL */ `
    query WpTour {
      allWpEatDrink(
        filter: {
          parentId: { eq: null }
          barCategory: { nodes: { elemMatch: { slug: { ne: "shop" } } } }
          events: { nodes: { elemMatch: { name: { ne: null } } } }
        }
      ) {
        nodes {
          title
          excerpt
          parentId
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          restaurantContent {
            location
            eventEnquiry {
              target
              title
              url
            }
          }
          events {
            nodes {
              name
              slug
            }
          }
          locations {
            nodes {
              name
              slug
            }
          }
        }
      }
      allWpLocation(sort: { termTaxonomyId: ASC }) {
        nodes {
          name
          slug
        }
      }
    }
  `)

  const allLocationData = data.allWpLocation.nodes
  const postData = data.allWpEatDrink.nodes

  const dataArray = allLocationData

  const arrayLimit = 6
  const [location, setLocation] = useState("all")
  const [filteredData, setFilteredData] = useState(
    dataArray.slice(0, arrayLimit)
  )
  const [showLoadMore, setShowLoadMore] = useState(true)
  const [filteredAllData, setFilteredAllData] = useState(dataArray)

  const handleSearchClick = () => {
    if (location === "all") {
      // If "all" is selected, show all posts
      setFilteredData(postData.slice(0, arrayLimit))
      setShowLoadMore(postData.length > arrayLimit)
      setFilteredAllData(postData)
    } else {
      // If a specific location is selected, filter based on location
      const locArray = postData.filter(item => {
        const locationSlugs = item.locations.nodes.map(node => node.slug)
        const isLocationMatch = !location || locationSlugs.includes(location)
        return isLocationMatch
      })
      setFilteredData(locArray.slice(0, arrayLimit))
      setShowLoadMore(locArray.length > arrayLimit)
      setFilteredAllData(locArray)
    }
  }

  const handleLoadMoreClick = () => {
    const nextItems = filteredData.length + arrayLimit
    setFilteredData(filteredAllData.slice(0, nextItems))
    setShowLoadMore(filteredAllData.length > nextItems)
  }

  useEffect(() => {
    handleSearchClick()
  }, [location])

  if (module.hideSection === "no") {
    return (
      <section className="bg-white-100 ">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`category-listing py-75 lgscreen:py-30 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="anim"
          >
            <div className="flex flex-col justify-center text-center px-20">
              {module?.heading && (
                <motion.h2 variants={animFade}>{module.heading}</motion.h2>
              )}
              <motion.div
                variants={animFade}
                className="filter-listing flex flex-wrap smscreen2:flex-col gap-2 items-center gap-x-2 justify-center mt-30"
              >
                <select
                  value={location}
                  onChange={e => {
                    setLocation(e.target.value)
                    handleSearchClick()
                  }}
                  className="border-1 border-charcoal rounded-2 w-[350px] ipad:w-[270px] smscreen2:w-full py-[11px] px-15 outline-none"
                >
                  <option value="all">All Locations</option>
                  {allLocationData.map((item, i) => {
                    return (
                      <option key={i} value={item.slug}>
                        {item.name}
                      </option>
                    )
                  })}
                </select>
                <button
                  onClick={handleSearchClick}
                  className="btn btn-black smscreen2:w-full"
                >
                  search
                </button>
              </motion.div>
            </div>

            <div className="container-fluid">
              <div className="accordian-container">
                <div className="tab-content">
                  <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[120px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                    {filteredData.length > 0 &&
                      filteredData.map((item, k) => {
                        return (
                          item.parentId === null && (
                            <div
                              className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                              key={k}
                            >
                              <motion.div
                                variants={animFade2}
                                className="category-bx"
                              >
                                {item?.featuredImage && (
                                  <Link to={item.uri}>
                                    <div className="img relative">
                                      <ImageOpt
                                        imgData={
                                          item.featuredImage.node.mediaItemUrl
                                        }
                                        width={900}
                                        height={600}
                                        imgAlt={item.featuredImage.node.altText}
                                        imgLoad="lazy"
                                      />
                                    </div>
                                  </Link>
                                )}
                                <div className="category-content pt-25">
                                  {item?.title && <h4>{item.title}</h4>}
                                  {item?.restaurantContent?.location && (
                                    <div className="flex flex-wrap gap-x-[5px] py-10">
                                      <img
                                        src="../images/location-black.svg"
                                        width={12}
                                        height={12}
                                        loading="lazy"
                                        alt="Location"
                                      />
                                      <span className="font-ositalic text-13">
                                        {item.restaurantContent.location}
                                      </span>
                                    </div>
                                  )}
                                  {item?.excerpt && (
                                    <div className="content w-full pr-30">
                                      {parse(item.excerpt)}
                                    </div>
                                  )}
                                  <div className="flex flex-wrap gap-x-2 gap-y-2 mt-25">
                                    {item?.restaurantContent?.eventEnquiry && (
                                      <Link
                                        to={
                                          item.restaurantContent.eventEnquiry
                                            .url
                                        }
                                        className="btn btn-black"
                                        target={
                                          item.restaurantContent.eventEnquiry
                                            .target
                                        }
                                      >
                                        {
                                          item.restaurantContent.eventEnquiry
                                            .title
                                        }
                                      </Link>
                                    )}
                                    {item.title !== "The Marly" &&
                                      item.title !== "The Alphen" && (
                                        <Link
                                          to={item.uri}
                                          className="btn btn-border"
                                        >
                                          explore
                                        </Link>
                                      )}
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          )
                        )
                      })}
                  </div>

                  {showLoadMore && (
                    <motion.div
                      variants={animFade}
                      className="flex flex-wrap justify-center mt-75 lgscreen:mt-35"
                    >
                      <button
                        className="btn btn-border opacity-50"
                        onClick={handleLoadMoreClick}
                      >
                        Load More
                      </button>
                    </motion.div>
                  )}

                  {filteredData.length === 0 && (
                    <div className="flex flex-wrap justify-center mt-75 lgscreen:mt-35">
                      <div className="content text-center">
                        <h3>
                          No results found, please filter through our properties
                          again.
                        </h3>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default PlanYourEventListing
export const PagePlanYourEventListingFragment = graphql`
  fragment PagePlanYourEventListingFragment on WpPage_Pagecontent_PageContent_PlanYourEventListing {
    extraId
    extraClass
    hideSection
    heading
  }
`
